import React, { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { FileUp, Loader2 } from "lucide-react";
import { toast } from "sonner";

export const WorkbookUpload = () => {
  const [meta, setMeta] = useState(null);
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    api.get("/admin/workbook").then((r) => setMeta(r.data)).catch(() => {});
  }, []);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const form = new FormData();
    form.append("file", file);
    setUploading(true);
    try {
      const r = await api.post("/admin/workbook", form);
      setMeta(r.data);
      toast.success("Workbook uploaded. Buyers can download it now.");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Upload failed");
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  return (
    <>
      <input ref={inputRef} type="file" accept="application/pdf" className="hidden" onChange={upload} data-testid="workbook-file-input" />
      <button
        onClick={() => inputRef.current?.click()}
        disabled={uploading}
        data-testid="upload-workbook-btn"
        title={meta?.uploaded ? `Current: ${meta.filename}` : "No workbook uploaded yet"}
        className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-[#2A3B32]/15 text-sm text-[#1C221D] hover:bg-[#2A3B32] hover:text-[#FDFBF7] transition-colors duration-200 disabled:opacity-60"
      >
        {uploading ? <Loader2 size={14} className="animate-spin" /> : <FileUp size={14} />}
        {meta?.uploaded ? "Replace workbook PDF" : "Upload workbook PDF"}
      </button>
    </>
  );
};

export default WorkbookUpload;
